import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IconSize } from '@psei/ng/api';
import { ButtonFlavor, ButtonType } from 'projects/ppb-shared-library/src/lib/models/button-config.model';
import { CustomValidators } from 'projects/ppb-shared-library/src/lib/services/form/custom-validators';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ServerConfigModel } from '../../technical/version/server-config.model';
import { AccountService } from '../ppb-account/account.service';
import { ppbToggles } from '../shared/models/ppb-toggles';

@Component({
  selector: 'ppb-register-account',
  templateUrl: './ppb-account-registration.component.html',
  styleUrls: ['./ppb-account-registration.component.scss']
})
export class PpbAccountRegistrationComponent {

  iconSize: IconSize = IconSize.Small;
  accountForm: UntypedFormGroup;
  ButtonType = ButtonType;
  flavor: ButtonFlavor.SECONDARY;
  configuration: ServerConfigModel;
  finished = false;
  isLoading$ = new BehaviorSubject(false);
  isDisabled$ = new BehaviorSubject(true);
  delay: number = 250;
  private subs = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private cd: ChangeDetectorRef) {

    this.accountForm = this.fb.group({
      firstName: new UntypedFormControl('', {
        validators: [
          Validators.required, CustomValidators.firstName(),
          CustomValidators.trimSpacesValidator($localize`:@@account.invalid_first_name:Niepoprawne imię`)]
      }),
      lastName: new UntypedFormControl('', {
        validators: [
          Validators.required, CustomValidators.lastName(),
          CustomValidators.trimSpacesValidator($localize`:@@account.invalid_last_name:Niepoprawne nazwisko`)]
      }),
      email: new UntypedFormControl('',
        { validators: [Validators.required, CustomValidators.email()] }),
      phone: new UntypedFormGroup({
        number: new UntypedFormControl('',
          { validators: [Validators.required, CustomValidators.phone()], updateOn : 'change'}),
        prefix: new UntypedFormControl(null,
          { validators: [Validators.required] })
      }),
      sharePhone: new UntypedFormControl(),
      code: new UntypedFormControl('', { validators: [Validators.required] }),
      rulesAgreement: new UntypedFormControl('', { validators: [Validators.requiredTrue] }),
      privacyPolicyAgreement: new UntypedFormControl('', { validators: [Validators.requiredTrue] })
    });
    this.configuration = this.route.snapshot.data.configuration;
    this.subs.add(this.isLoading$.subscribe(loading => {
      loading ? this.accountForm.disable() : this.accountForm.enable();
      this.cd.markForCheck();
    }));
    this.subs.add(this.accountForm.valueChanges.subscribe(() => {
      this.isDisabled$.next(!this.accountForm.valid);
    }))
  }

  submitNewAccount(): void {
    this.accountForm.patchValue(this.accountForm.value);
    this.accountForm.markAllAsTouched();
    this.accountForm.updateValueAndValidity();
    const registrationData = { registrationType: 'REGISTRATION_CODE', ...this.accountForm.value };
    if (this.accountForm.valid) {
      this.isLoading$.next(true);
      this.accountService.registerAccount(registrationData)
        .subscribe(_ => {
            this.finished = true;
            this.cd.markForCheck();
          },
          _ => {
            this.isLoading$.next(false);
          });
    }
  }

  handleSubmit(): void {
    if (!this.accountForm.valid) {
      return;
    } else {
      this.submitNewAccount()
    }
  }

  get email(): string {
    return this.accountForm.controls['email'].value;
  }

  handleBackClick(): void {
    this.router.navigate(['/']);
  }

}
